import { DAP_STUDENT_EXAM_SETUP_STATUS, DAP_STUDENT_EXAM_SETUP_STATUS_MAP } from './bluebox';

// eslint-disable-next-line
export function examSetupDisplay(student: any) {
  type Keys = keyof typeof DAP_STUDENT_EXAM_SETUP_STATUS;
  type ExamSetupStatus = (typeof DAP_STUDENT_EXAM_SETUP_STATUS)[Keys];
  // For some record that student doesn't have dapExamStatus, we will set it to NOT_STARTED
  const dapExamStatus: ExamSetupStatus = student.dapExamStatus?.name ?? DAP_STUDENT_EXAM_SETUP_STATUS.NOT_STARTED;
  return DAP_STUDENT_EXAM_SETUP_STATUS_MAP[dapExamStatus];
}

// eslint-disable-next-line
export function examStatusSort(student: any) {
  switch (student?.dapExamStatus?.name) {
    case DAP_STUDENT_EXAM_SETUP_STATUS.EXAM_SETUP_COMPLETE:
    case DAP_STUDENT_EXAM_SETUP_STATUS.EXAM_PACKAGE_DOWNLOADED:
      return 4;
    case DAP_STUDENT_EXAM_SETUP_STATUS.EXAM_SETUP_STARTED:
      return 3;
    case DAP_STUDENT_EXAM_SETUP_STATUS.EXAM_CHECKIN_COMPLETED:
      return 2;
    case DAP_STUDENT_EXAM_SETUP_STATUS.NOT_STARTED:
      return 1;
    default:
      return 1;
  }
}
